import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";

@Injectable({
  providedIn: 'root'
})
export class AdminAuthenticationService {

  constructor(
    private httpClient: HttpClient
  ) {}

  login(password: string): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + '/admin/login',
      { password },
      { withCredentials: true }
    );
  }

  checkAuthentication(): Observable<void> {
    return this.httpClient.get<void>(
      Configuration.getApiBaseUrl() + '/admin/check',
      { withCredentials: true }
    );
  }

  logout(): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + '/admin/logout',
      {},
      { withCredentials: true }
    );
  }
}